export default function LoadingSpinner() {
  return (
    <div className="flex flex-col items-center gap-4">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      
      <div className="flex items-center gap-1 text-[10px] font-black uppercase tracking-[0.2em] text-gray-400">
        <span>Just a second</span>
        <span className="dot-animation w-6 text-left"></span>
      </div>

      <style>{`
        .dot-animation::after {
          content: '';
          animation: loading-dots 1.5s steps(4, end) infinite;
        }
        @keyframes loading-dots {
          0%, 20% { content: ''; }
          40% { content: '.'; }
          60% { content: '..'; }
          80%, 100% { content: '...'; }
        }
      `}</style>
    </div>
  )
}
